import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { Observable, ReplaySubject} from 'rxjs';
import { first, take } from 'rxjs/operators';
import { BlockedNip } from '../interface/blockedNip';
import { Uuid } from '../interface/response/uuid';
import { CountedAndPaginated } from '../interface/response/counted-and-paginated';
import {FilterService} from "./filter.service";

@Injectable({
  providedIn: 'root'
})
export class BlockedNipService {
  private readonly blockedNipListSubject: ReplaySubject<CountedAndPaginated<BlockedNip>>
    = new ReplaySubject<CountedAndPaginated<BlockedNip>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
  ) {}

  public loadList(page: number, pageSize: number, filters: object, sort?: { sortBy?: string; sortOrder?: string }): void {
    const sortBy = sort?.sortBy || 'createdAt';
    const sortOrder = sort?.sortOrder || 'ASC';

    this.httpClient.get(`/rest/crm/blocked-nip?page=${page + 1}&pageSize=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: CountedAndPaginated<BlockedNip>) => {
        this.blockedNipListSubject.next(result);
      });
  }

  public blockNip(formData: object): Observable<Uuid> {
    return this.httpClient.post<Uuid>('/rest/crm/block-nip', formData)
      .pipe(take(1));
  }

  public delete(uuid: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/blocked-nip/${uuid}`)
      .pipe(first());
  }

  public downloadReport(filters: object): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/blocked-nip/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

  public getBlockedNipListSubject(): ReplaySubject<CountedAndPaginated<BlockedNip>> {
    return this.blockedNipListSubject;
  }

}
